module.exports = __webpack_public_path__ + "img/coverImage_example.1e3441b2.jpg";